module.exports = __webpack_public_path__ + "img/page_paper_file_document_downloads_icon.9f778cca.svg";